export class PrestationCode {
  code: string;
  labelFR: string;
  labelNL: string;
  labelEN: string;
  labelDE: string;
}
